import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div
      className="container px-3 footer-container"
    >
      {/*<div
        className="d-flex flex-column flex-md-row align-items-center justify-content-between w-100"
        style={{ minHeight: 80, height: 'auto', gap: 12 }}
      >
        <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start" style={{ gap: 8, width: '100%', justifyContent: 'center', justifyContent: 'flex-start', padding: '8px 0' }}>
          <div className="d-flex flex-column align-items-center align-items-md-start" style={{ gap: 4 }}>
            <div className="d-flex flex-column align-items-center" style={{ gap: 0 }}>
              <div className="d-flex align-items-center justify-content-center" style={{ gap: 12 }}>
                <img src="/logo.png" alt="Logo" style={{ height: 48, backgroundColor: '#f8a706', borderRadius: 50, marginBottom: 0 }} />
                <span style={{ fontWeight: 700, fontSize: 18, color: '#fff', letterSpacing: 1, marginLeft: 8 }}>Cardoso Imóveis</span>
              </div>
              <div className="d-flex align-items-center justify-content-center mt-2" style={{ gap: 10 }}>
                <a href="#" className="text-white" style={{ fontSize: 18 }}><i className="fab fa-facebook-f"></i></a>
                <a href="#" className="text-white" style={{ fontSize: 18 }}><i className="fab fa-twitter"></i></a>
                <a href="#" className="text-white" style={{ fontSize: 18 }}><i className="fab fa-linkedin-in"></i></a>
                <a href="#" className="text-white" style={{ fontSize: 18 }}><i className="fab fa-instagram"></i></a>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column align-items-center align-items-md-end justify-content-center mt-3 mt-md-0" style={{ minWidth: 220, width: '100%' }}>
          <div style={{ fontWeight: 700, fontSize: 16, letterSpacing: 1, color: '#fff', marginBottom: 2, textAlign: 'center' }}>
            Detalhes de Contato
          </div>
          <div style={{ color: '#b0b8c1', fontSize: 15, textAlign: 'center', marginBottom: 0 }}>
            <div>contato@exemplo.com</div>
            <div>+552 534-468-854</div>
          </div>
        </div>
      </div>*/}
      <div className="footer-bottom">
        <label className="footer-label">© 2025 {process.env.REACT_APP_COMPANY_NAME || 'ProConstru'}. Todos os direitos reservados.</label>
      </div>
    </div>
  </footer>
);

export default Footer;
